<template>
  <Transition name="slide-fade" mode="out-in" appear>
    <div class="header-download-wrapper flex-between" v-show="showTopDownload">
      <div class="flex-start">
        <van-button class="close-btn" icon="cross" type="default" size="small" @click="close(!0)" />
        <img class="logo" v-lazy="downloadLogoSrc" />
        <div class="text">
          <p>下载APP领8888红包！</p>
          <p class="desc">联系在线客服申领</p>
        </div>
      </div>
      <van-button class="download-btn" type="primary" block @click="downloadHandle">立即下载</van-button>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from '@star/languages';
import { storeToRefs, useModalStore, useTenantStore } from '@star/stores';
import { useDownloadApp } from '@/hooks';

const { n } = useI18n();
const { downloadLogoSrc } = storeToRefs(useTenantStore());
const { isShowTopDownload } = storeToRefs(useModalStore());
const { showTopDownload, close, downloadHandle, init } = useDownloadApp('top');

onMounted(() => {
  if (!isShowTopDownload.value) {
    setTimeout(() => {
      init('top');
    }, 0);
  }
});
</script>

<style lang="less" scoped>
.header-download-wrapper {
  width: 100%;
  height: var(--header-height);
  overflow: hidden;
  padding-left: 15px;
  padding-right: 42px;
  background: #2c3a3b;

  .close-btn {
    border: none;
    color: #bbb6b6;
    background: transparent;
  }

  .logo {
    height: 78px;
    margin-left: 24px;
  }

  .text {
    font-size: 36px;
    font-weight: 500;
    color: #e0ab4b;
    margin-left: 30px;
    white-space: nowrap;
    line-height: 1.2;
    margin-top: 3px;

    .desc {
      font-size: 30px;
      font-weight: 400;
      margin-top: 6px;
    }
  }

  .download-btn {
    width: 260px;
    height: 72px;
    border-radius: 15px;
    font-size: 36px;
    font-weight: 380;
    padding: 0 30px;
  }
}

.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}

.slide-fade-enter-from {
  transform: translateY(-80px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-120px);
  height: 0;
  opacity: 0;
}
</style>
